<template>
  <el-dialog title="添加课程" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form class="el-cus" ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="添加课程：" prop="name" class="width100">
        <!-- <el-select v-model="value" multiple filterable remote reserve-keyword placeholder="请输入关键词" :popper-append-to-body="false" :remote-method="remoteMethod" :loading="loading">
          <el-option v-for="item in exerciseOptions" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select> -->
        <el-cascader v-model="value" :options="exerciseOptions" ref="cascader" @change="changeCascader" :props="props" :show-all-levels="false" filterable clearable></el-cascader>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import courseScenarioExerciseApi from '@/api/course/courseScenarioExercise'
import courseClassificationApi from '@/api/course/courseClassification'

export default {
  data() {
    return {
      value: '',
      formVisible: false,
      exerciseOptions: [],
      props: {
        multiple: true,
        children: 'classificationChildList',
        label: 'typeName',
        value: 'id'
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(query, type) {
      courseClassificationApi.getClassificationCourseSubject({ categoryId: 2 }).then(({ data }) => {
        this.exerciseOptions = this.formatCascaderData(data);
        if (type) this.formVisible = true
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (!data[i].classificationChildList || (data[i].classificationChildList && !data[i].classificationChildList.length)) {
          // children若为空数组，则将children设为undefined
          data[i].courseSubjectList.forEach(it => { it.typeName = it.name; })
          data[i].classificationChildList = data[i].courseSubjectList;
        } else {
          this.formatCascaderData(data[i].classificationChildList)
        }
      }
      return data
    },
    handleCourse() {
      this.value = ''
      this.getList("", 1)

    },
    changeCascader() {
      let node = this.$refs.cascader.getCheckedNodes(true);
      let arr = []
      node.forEach(item => {
        let e = item
        arr.push({ name: e.label, id: e.value, type: e.data.type, chapterNum: e.data.chapterNum })
      })
      this.selectArr = arr
    },
    doCreate() {
      if (!this.selectArr) return this.$message.error('请选择课程')
      this.$emit('created', this.selectArr)
      this.formVisible = false
    },
  }
}
</script>
<style lang="scss" scoped>
.el-cus {
  padding: 0 15px;
}
::v-deep .el-select-dropdown.el-popper {
  max-width: 600px !important;
}
</style>
